<template>
  <div class="content">
    <div class="logo-container">
      <img src="../assets/img/general/logo-satab.png" alt="Satab" />
    </div>
    <div class="site-content">
      <slot></slot>
    </div>
    <div id="footer-container">
      <TopFooter />
      <Footer />
    </div>
  </div>
</template>

<script>
import TopFooter from "../components/structure/TopFooter";
import Footer from "../components/structure/Footer";

export default {
  components: {
    TopFooter,
    Footer
  }
};
</script>

<style scoped>
.content {
  background-image: url("../assets/img/general/background.png"),
    linear-gradient(73deg, #d9deeb 0%, #f5f5f500 100%);
  background-position: 140% top;
  background-repeat: no-repeat;
}
.site-content {
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-container {
  max-width: 230px;
  position: absolute;
}

@media screen and (max-width: 800px) {
  .logo-container {
    position: relative;
    margin: auto;
    padding: 20px
  }
  #auth {
    padding: 0px;
  }
}
</style>